import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useCookies } from "react-cookie";
import { Navigate, useNavigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const navigate = useNavigate();
  /// cookie section start ///
  const [cookies, setCookies, removeCookies] = useCookies();
  /// cookie section end ///
  const [isAgentLogedIn, setIsAgentLogedIn] = useState(false);

  return children;
}
